/**
 * Mixin: Esc event
 * -----------------------------------------------------------------------------
 * Mixin to trigger events based on a global esc key event.
 *
 */
import {on} from '../helpers/utils';
import bind from '../mixins/bind';

/**
 * Export esc event helper.
 */
export default () => {

  /**
   * Initialise component bind to prevent double binds.
   */
  const binder = bind(document.documentElement, {
    className: 'esc-bind',
  });

  /**
   * Set Esc keyboard event.
   * @param {Event} event - Keycode event set on document.
   */
  function onEscEvent(event) {
    if (!isKeyPressIsEsc(event) || !binder.isSet()) {
      return;
    }

    Frame.EventBus.emit('EscEvent:on');
    binder.remove();
  }

  /**
   * Check if Esc is pressed.
   * @param {Event} event - Keycode event passed from document.
   */
  function isKeyPressIsEsc(event) {
    return event.keyCode === 27;
  }

  /**
   * Listen for keydown events.
   */
  function setKeyDownToggleEvent() {
    if (binder.isSet()) {
      return;
    }

    on('keydown', (event) => onEscEvent(event));
    binder.set();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    set: setKeyDownToggleEvent,
  });
};
